import { logoutStates } from './states';

export default function(appModule) {
  appModule.config(logoutStates);
}
